import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores/authStore';

/**
 * Wait for zustand/persist to rehydrate from localStorage, then optionally validate JWT via /auth/me.
 * Without this, the first paint can use stale defaults and PrivateRoute may not redirect to /login.
 */
export default function AuthReady({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const waitHydration = () =>
      new Promise((resolve) => {
        if (useAuthStore.persist.hasHydrated()) {
          resolve();
          return;
        }
        const unsub = useAuthStore.persist.onFinishHydration(() => {
          unsub();
          resolve();
        });
      });

    const run = async () => {
      await waitHydration();
      if (cancelled) return;
      const { token, checkAuth } = useAuthStore.getState();
      if (token) {
        try {
          await checkAuth();
        } catch {
          /* checkAuth handles 401/403 */
        }
      }
      if (!cancelled) setReady(true);
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-600 text-sm">
        Loading session…
      </div>
    );
  }

  return children;
}
